import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TeacherRoutingModule } from './teacher-routing.module';
import { TeacherComponent } from './teacher.component';
import { SpinnerModule } from 'src/app/common/spinner/spinner.module';
import { CourseGridModule } from 'src/app/common/course-grid/course-grid.module';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [TeacherComponent],
  imports: [
    CommonModule,
    CourseGridModule,
    TeacherRoutingModule,
    SpinnerModule,
    MatButtonModule,
    FontAwesomeModule,
  ]
})
export class TeacherModule { }
